import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { MessageCircle, Menu, X } from "lucide-react";

const NAV = [
  { to: "/meditation-enlightenment", label: "Meditation Enlightenment" },
  { to: "/bliss-path", label: "Bliss Path" },
  { to: "/aura-night", label: "Aura Night" },
  { to: "/meditations", label: "Meditations" },
  { to: "/one-to-one", label: "iC One-to-One" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/about", label: "About" },
];

export default function PublicLayout() {
  const loc = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="min-h-screen flex flex-col grain-bg text-foreground">
      <header className="sticky top-0 z-30 backdrop-blur-md bg-[#FDFBF7]/80 border-b border-[#EBE5D9]/80">
        <div className="container-ic !max-w-7xl flex items-center justify-between gap-6 py-5">
          <Link to="/" data-testid="brand-link" className="font-serif text-2xl text-terracotta tracking-wide">
            iChaitanya
          </Link>
          <nav className="hidden xl:flex items-center gap-6 text-sm text-[#5C5955]">
            {NAV.map(n => (
              <Link key={n.to} to={n.to}
                data-testid={`nav-${n.to.slice(1)}`}
                className={`whitespace-nowrap hover:text-terracotta transition ${loc.pathname === n.to ? "text-terracotta" : ""}`}>
                {n.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <Link to="/meditation-enlightenment" className="hidden sm:inline-flex btn-primary text-xs whitespace-nowrap" data-testid="header-join-btn">
              Join Meditation Enlightenment
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen(o => !o)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              data-testid="mobile-menu-toggle"
              className="xl:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg text-[#4A3B32] hover:text-terracotta transition">
              {menuOpen ? <X size={24}/> : <Menu size={24}/>}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="xl:hidden border-t border-[#EBE5D9] bg-[#FDFBF7]" data-testid="mobile-menu">
            <nav className="container-ic py-4 flex flex-col gap-1">
              {NAV.map(n => (
                <Link key={n.to} to={n.to}
                  onClick={() => setMenuOpen(false)}
                  data-testid={`mobile-nav-${n.to.slice(1)}`}
                  className={`py-2.5 text-base border-b border-[#EBE5D9]/60 last:border-0 transition ${loc.pathname === n.to ? "text-terracotta" : "text-[#4A3B32] hover:text-terracotta"}`}>
                  {n.label}
                </Link>
              ))}
              <Link to="/meditation-enlightenment" onClick={() => setMenuOpen(false)}
                className="btn-primary text-xs mt-3 text-center" data-testid="mobile-join-btn">
                Join Meditation Enlightenment
              </Link>
            </nav>
          </div>
        )}
      </header>
      <main className="flex-1"><Outlet /></main>
      <footer className="border-t border-[#EBE5D9] bg-[#F3EFEA] mt-20">
        <div className="container-ic py-12 grid md:grid-cols-3 gap-10 text-sm">
          <div>
            <div className="font-serif text-2xl text-terracotta">iChaitanya</div>
            <p className="mt-3 text-[#7E736E]">Meditation is already within you. We help you return to it consciously.</p>
          </div>
          <div>
            <div className="font-medium mb-3 text-[#4A3B32]">Programs</div>
            <ul className="space-y-2 text-[#7E736E]">
              {NAV.slice(0,4).map(n => (
                <li key={n.to}><Link to={n.to} className="hover:text-terracotta">{n.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-medium mb-3 text-[#4A3B32]">Contact</div>
            <ul className="space-y-2 text-[#7E736E]">
              <li>support@ichaitanya.com</li>
              <li>WhatsApp: +91 92176 39689</li>
              <li><Link to="/admin/login" className="hover:text-terracotta" data-testid="admin-login-link">Admin</Link></li>
            </ul>
          </div>
        </div>
        <div className="container-ic py-6 text-xs text-[#7E736E] border-t border-[#EBE5D9]">© {new Date().getFullYear()} iChaitanya. All rights reserved.</div>
      </footer>

      {/* Site-wide floating WhatsApp button */}
      <a
        href="https://wa.me/919217639689?text=Hi%2C%20I%20have%20a%20question%20about%20iChaitanya%20programs"
        target="_blank" rel="noreferrer"
        aria-label="Chat with us on WhatsApp"
        data-testid="wa-float"
        className="fixed bottom-6 right-6 z-40 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition"
      >
        <MessageCircle size={26}/>
      </a>
    </div>
  );
}
